<template>
  <div class="container">
    <div class="panel text-center">
      <template v-if="setupRequired">
        <h1>Setup Required</h1>
        <p v-if="userFetchError === 'primary_user_absent'">
          Before you can use rradarreport with this company, a primary user needs to log in and be assigned as the
          manager.
        </p>
        <p v-if="userFetchError === 'primary_user_doesnt_exist'">
          The manager for your company in rradarreport is no longer a registered user and so a new manager needs to be
          assigned. Only a primary user for your company can be the manager.
        </p>
        <p>
          Please ask one of the following people to log in to rradarreport and they will be automatically set as the
          new manager.
        </p>
        <div v-for="user in companyPrimaryUsers" :key="user.email">
          <div>{{ user.name }} (<a :href="'mailto:' + user.email">{{ user.email }}</a>)</div>
        </div>
      </template>
      <template v-else>
        <h1>User Account Error</h1>
        <p v-html="userFetchError"></p>
      </template>

      <div class="flex flex--horiz-center spacing">
        <themed-button :href="switchCompanyUrl">Switch Company</themed-button>
          <themed-button class="spacing-left" @click="$emit('logoutUser')">Log out</themed-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'user-fetch-error',

  props: ['switchCompanyUrl'],

  computed: {
    ...mapState({
      userFetchError: state => state.user.userFetchError,
      companyPrimaryUsers: state => state.user.companyPrimaryUsers,
    }),

    setupRequired() {
      return ['primary_user_absent', 'primary_user_doesnt_exist'].includes(this.userFetchError);
    },
  },
};
</script>
